/**
 * Basic Ad Unit class containing all values needed for rendering.  No details about rendering just
 * common metadata.
 * @param {String} _id              [description]
 * @param {Function} _getCustomValues [description]
 */
var AdUnit = function(_id, _zones, _getCustomValues, _correlator, _getModuleValue) {
    var _containerId;
    var _retargetCount = 0;
    var _customValues = {};
    var rendered = false;
    /**
     * Unique id for this ad unit
     * @return {[type]} [description]
     */
    this.getId = function() {
        return _id;
    };

    /**
     * Return how many times this ad unit has been retargeted.
     * @return {Number}
     */
    this.getRetargetCount = function() {
        return _retargetCount;
    };

    /**
     * True if there is a gpt Slot for this adUnit.
     * @return {Boolean} [description]
     */
    this.isRendered = function() {
        return rendered;
    };

    /**
     * sets the rendered flag.
     */
    this.setRendered = function() {
        rendered = true;
    };

    this.setCorrelator = function(correlator) {
        _correlator = correlator;
    };

    this.getCorrelator = function() {
        return _correlator;
    };

    /**
     * Gets custom values unique to this ad unit which includes supported ad unit sizes.
     * @return {[type]} [description]
     */
    this.getCustomValues = function() {
        // TODO: possible logic to handle custom targeting based on provided values from async-gpt-tag
        if(!_customValues) {
            _customValues = {
                adname: null
            };

            $.extend(_customValues, _getCustomValues());
        }

        return _customValues;
    };

    /**
     * The unique Id for the container for the ad unit.  This value will changes are the ad is retargeted
     * and possibly even when refreshed.
     *
     * @return {[type]} [description]
     */
    this.getContainerId = function(){
        if(!_containerId) {
            _containerId = this.getId() + '-' + this.getRetargetCount();
        }

        return _containerId;
    };

    this.getRefreshZones = function() {
        return _zones.slice();
    };

    this.getModuleValue = function() {
        return _getModuleValue();
    };

    /**
     * when retargeting is needed.  Different than refreshing.
     * @return {[type]} [description]
     */
    this.retarget = function(){
        rendered = false;
        _retargetCount++;
        _containerId = null;
        _customValues = null;
    };
};

/**
 * [currentSizes description]
 * @return {Array} Array of arrays defining the different sizes this ad unit supports.
 */
AdUnit.prototype.currentSizes = function(){
    var values = this.getCustomValues();
    return values.sizes.slice();
};

AdUnit.prototype.getCustomTargetingValues = function(){
    var values = this.getCustomValues();
    return values.customValues;
};

/**
 * Gets key value pairs unique to this ad unit.  Typically these values will be passed to GPT
 * @return {[type]} [description]
 */
AdUnit.prototype.getTargetingValues = function(){
    var values = this.getCustomValues();
    var context = {};
    $.extend(context, values);

    delete context.sizes;

    delete context.customValues;

    return context;
};


module.exports = AdUnit;



//////////////////
// WEBPACK FOOTER
// ./src/interlock/product/ads/ad-unit-factory/ad-unit.js
// module id = 448
// module chunks = 36